// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-69c62637] .v-application--wrap,[data-v-69c62637] .v-main{max-height:100vh;overflow:hidden}.campaign-container[data-v-69c62637]{height:100%!important;width:100%!important;max-width:100%!important;overflow:auto}", ""]);
// Exports
module.exports = exports;
